import React from 'react';
import Creditcard from './images/credit.png';

const Icon3 = () => {
    return (
        <div className="container-fluid" >
            <img src={Creditcard} alt="credit card icon" className="img-fluid" style={{maxWidth: "100%"}} />
        </div>
    )
}

export default Icon3
